import type {CouponHistory} from '../../types';

import {LeftOutlined} from '@ant-design/icons';
import {Loading} from '@ds/components';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router-dom';

import CouponStatus from '../../../components/common/CouponStatus/CouponStatus';
import {COUPON_ROUTES} from '../../../constants';

type CouponHistoryListProps = {
  history: CouponHistory;
  isLoadingMore: boolean;
  onLoadMore: () => void;
};

const CouponHistoryList: React.FC<CouponHistoryListProps> = ({
  history,
  isLoadingMore,
  onLoadMore
}) => {
  const navigate = useNavigate();

  return (
    <InfiniteScroll
      next={onLoadMore}
      dataLength={history.coupons.length}
      scrollableTarget="coupon-history-list"
      hasMore={history.coupons.length < history.total_items}
      loader={
        isLoadingMore ? (
          <div className="flex h-10 justify-center">
            <Loading size="medium" color="primary" />
          </div>
        ) : null
      }
      scrollThreshold={0.6}
    >
      <div className="flex flex-col">
        {history.coupons.map((coupon) => (
          <button
            type="button"
            key={coupon.id}
            className="flex w-full items-center gap-2 border-b border-gray-22 px-4 py-3 text-start last:border-b-0 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange"
            onClick={() => navigate(COUPON_ROUTES.details.replace(':couponId', String(coupon.id)))}
          >
            <span className="flex min-w-0 flex-1 flex-col">
              <span className="text-body-sm-emphasis text-neutral-fg">{coupon.title}</span>
              <span className="text-body-sm text-gray-34">{coupon.description}</span>
            </span>
            <CouponStatus value={coupon.status} />
            <LeftOutlined aria-hidden className="shrink-0 text-body-lg text-gray-29" />
          </button>
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default CouponHistoryList;
